import { useEffect, useState } from 'react'
import { Empty } from 'antd'
import { get } from '@/utils/request'
import { FB, CategoryPill, Stars, OfficialReply } from '@/components/Feedback/Bubble'

type PublicItem = {
  id: string
  category: string | null
  content: string
  rating: number | null
  created_at: string
  official_replies: string[]
}

const fmtDate = (iso: string) => {
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? '' : `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}`
}

const PublicFeedback = () => {
  const [list, setList] = useState<PublicItem[]>([])

  useEffect(() => {
    get('feedbacks/public').then((res) => {
      if (res?.ok) setList(res.data)
    })
  }, [])

  return (
    <div className="min-h-screen" style={{ background: FB.page }}>
      <div className="mx-auto max-w-2xl px-4 py-10">
        <h1 className="mb-2 text-[28px] font-semibold tracking-tight" style={{ color: FB.ink }}>
          大家的反馈 · 官方公开答复
        </h1>
        <p className="mb-6 text-[15px] leading-relaxed" style={{ color: FB.muted }}>
          这里公开展示用户提出的部分反馈与灵缇官方的答复，匿名呈现。我们相信，把问题摆到台面上，是对每一位用户最好的尊重。
        </p>
        {list.length === 0 ? (
          <Empty description="暂无公开反馈" />
        ) : (
          <div className="flex flex-col gap-4">
            {list.map((item) => (
              <div key={item.id} className="rounded-3xl bg-white p-5 shadow-sm ring-1 ring-black/5">
                <div className="mb-2.5 flex items-center gap-2">
                  <CategoryPill category={item.category} />
                  <Stars value={item.rating} />
                  <span className="ml-auto text-xs" style={{ color: FB.muted }}>
                    {fmtDate(item.created_at)}
                  </span>
                </div>
                <div className="whitespace-pre-wrap text-[15px] leading-relaxed" style={{ color: FB.ink }}>
                  {item.content}
                </div>
                {item.official_replies.map((r) => (
                  <OfficialReply key={r} text={r} />
                ))}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default PublicFeedback
